import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axiosinstances, { baseURL } from "../../Helper/useAxios";
import "./profile.css";
import { isSuperAdmin } from "../../utils/comman/Common";

export default function Profile() {
  const navigate = useNavigate();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [axiosInstance] = axiosinstances();
  const [profileDetails, setProfileDetails] = useState();
  const [balance, setBalance] = useState("");
  const [bankDetails, setBankDetails] = useState(null);
  const profileId = useParams();
  //console.log('profileDetails', profileDetails)
  //console.log('profileId', profileId)
  const e = JSON.parse(sessionStorage.getItem("token"));
  const getprofileserviicesresponse = (data) => {
    return axiosInstance
      .get(`/api/v1/retailer/get/${profileId.id}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((response) => {
        if (response) {
          //console.log('res', response)
          const { data } = response;
          setProfileDetails(data);
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  };
  const getMerchnatDetailsresponse = () => {
    return axiosInstance
      .get(`/api/v1/payout/connector/get-merchant-details/${profileId.id}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((response) => {
        if (response) {
          //console.log('res', response)
          const { data } = response;
          if (data?.beneficiary !== undefined && data?.beneficiary !== null) {
            setBankDetails(data?.beneficiary);
          }
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  };
  const getbalanceresponse = () => {
    return axiosInstance
      .get(`/api/v1/account/balance/${profileId.id}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((response) => {
        if (response) {
          const { data } = response;
          //console.log('data', data)
          setBalance(data?.balance);
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  };
  useEffect(() => {
    if (id !== undefined) {
      getprofileserviicesresponse();
      getbalanceresponse();
      getMerchnatDetailsresponse();
    }
  }, [id]);
  //console.log('bankDetails', bankDetails)
  const handleDmt = (check) => {
    if (check === "DMT") {
      navigate(`/dmt-routing/${profileId.id}`);
    } else if (check === "MRECHARGE") {
      navigate(`/mobile-recharge-routing/${profileId.id}`);
    } else if (check === "RECHARGE") {
      navigate(`/recharge-routing/${profileId.id}`);
    } else if (check === "BILL_PAYMENT") {
      navigate(`/billpayment-routing/${profileId.id}`);
    }
  };
  const pancardDetails = (check) => {
    const pancardId =
      profileDetails?.kycInfo?.docs !== undefined &&
      profileDetails?.kycInfo?.docs !== null &&
      Array.isArray(profileDetails?.kycInfo?.docs) &&
      profileDetails?.kycInfo?.docs.length > 0 &&
      profileDetails?.kycInfo?.docs.filter((val) => val.type === check);
    return pancardId[0]?.id;
  };
  const toHistory = () => {
    navigate(`/account-history/${id}`);
  };

  return (
    <React.Fragment>
      <div class="mid">
        <div class="container-fluid">
          <div class="head">
            <h3>Profile</h3>
            <button class="btn" type="button" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>

          <div class="usercard">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-5">
                <div class="basicdtl">
                  {profileDetails?.businessInfo?.shopPic !== undefined &&
                    profileDetails?.businessInfo?.shopPic !== null && (
                      <img
                        src={profileDetails?.businessInfo?.shopPic}
                        alt="logo"
                      />
                    )}

                  <h5>
                    {profileDetails !== undefined &&
                      profileDetails?.businessInfo?.name !== undefined &&
                      profileDetails?.businessInfo?.name}
                  </h5>
                  <p>
                    Client ID:{" "}
                    {profileDetails?.id !== undefined && profileDetails?.id}
                  </p>
                </div>

                <div class="acnbtn">
                  <p>
                    Client status:{" "}
                    {profileDetails?.status !== undefined && (
                      <b>{profileDetails?.status}</b>
                    )}
                  </p>
                  <div style={{ float: "right" }}>
                    <p>
                      KYC status:{" "}
                      {profileDetails?.kycInfo?.status !== undefined && (
                        <b>{profileDetails?.kycInfo?.status}</b>
                      )}
                    </p>{" "}
                  </div>
                </div>

                <div class="protamnt mb-3">
                  <button type="button" class="btn dbbtn" onClick={toHistory}>
                    Transactions
                  </button>
                  <i class="ta"></i>
                  <p>TA Balance:</p>
                  <h3>₹ {balance}</h3>
                </div>
                <div className="routing-button">
                  <h3>Routing</h3>
                  <button
                    type="button"
                    class="btn dbbtn mr-2"
                    onClick={() =>
                      isSuperAdmin(id) ? handleDmt("DMT") : undefined
                    }
                  >
                    DMT Routing
                  </button>
                  <button
                    type="button"
                    class="btn dbbtn mr-2"
                    onClick={() =>
                      isSuperAdmin(id) ? handleDmt("MRECHARGE") : undefined
                    }
                  >
                    Mobile Rech. Routing
                  </button>
                  <button
                    type="button"
                    class="btn dbbtn mr-2"
                    onClick={() =>
                      isSuperAdmin(id) ? handleDmt("RECHARGE") : undefined
                    }
                  >
                    Recharge Routing
                  </button>
                  <button
                    type="button"
                    class="btn dbbtn  mt-1"
                    onClick={() =>
                      isSuperAdmin(id) ? handleDmt("BILL_PAYMENT") : undefined
                    }
                  >
                    Bill Pmt. Routing
                  </button>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-7">
                <div class="rightpro">
                  <div class="adrsdtl">
                    <h4>Contact Information</h4>

                    <p>Full Name:</p>
                    <h6>
                      {profileDetails?.personalInfo?.fname !== undefined &&
                        profileDetails?.personalInfo?.fname}{" "}
                      {profileDetails?.personalInfo?.lname !== undefined &&
                        profileDetails?.personalInfo?.lname}
                    </h6>

                    <p>Mobile Number:</p>
                    <h6>
                      +91-
                      {profileDetails?.personalInfo?.mobile !== undefined &&
                        profileDetails?.personalInfo?.mobile}
                    </h6>

                    <p>Company Email ID:</p>
                    <h6>
                      {profileDetails?.personalInfo?.email !== undefined &&
                        profileDetails?.personalInfo?.email}
                    </h6>

                    <p>PAN/TAN Number:</p>
                    <h6>{pancardDetails("PAN_CARD")}</h6>
                    <p>GST Number:</p>
                    <h6>{pancardDetails("GST_CERTIFICATE")}</h6>

                    <p>Address:</p>
                    <h6>
                      {" "}
                      {profileDetails?.businessInfo?.address?.fullAddress !==
                        undefined &&
                        profileDetails?.businessInfo?.address?.fullAddress !==
                          null &&
                        profileDetails?.businessInfo?.address?.fullAddress !==
                          "" &&
                        `FullAddress:- ${profileDetails?.businessInfo?.address?.fullAddress}`}
                    </h6>
                    <h6>
                      {profileDetails?.businessInfo?.address !== undefined &&
                        `${
                          profileDetails?.businessInfo?.address?.add1 !== null
                            ? `${profileDetails?.businessInfo?.address?.add1}, `
                            : ""
                        }${
                          profileDetails?.businessInfo?.address?.add2 !== null
                            ? `${profileDetails?.businessInfo?.address?.add2}, `
                            : ""
                        } ${
                          profileDetails?.businessInfo?.address?.city !== null
                            ? `${profileDetails?.businessInfo?.address?.city}, `
                            : ""
                        } ${
                          profileDetails?.businessInfo?.address?.state !== null
                            ? `${profileDetails?.businessInfo?.address?.state} - `
                            : ""
                        } ${
                          profileDetails?.businessInfo?.address?.pincode !==
                          null
                            ? profileDetails?.businessInfo?.address?.pincode
                            : ""
                        }`}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="usercard">
            <div class="row">
              <div class="col-12">
                <div style={{ borderLeft: "none" }} class="adrsdtl">
                  <h4>Bank Account Information</h4>

                  <p>Bank Name:</p>
                  <h6>
                    {bankDetails?.account?.bank !== undefined &&
                      bankDetails?.account?.bank !== null &&
                      bankDetails?.account?.bank}
                  </h6>

                  <p>Branch Name:</p>
                  <h6>
                    {bankDetails?.account?.branch !== undefined &&
                      bankDetails?.account?.branch !== null &&
                      bankDetails?.account?.branch}
                  </h6>

                  <p>IFSC:</p>
                  <h6>
                    {bankDetails?.account?.ifsc !== undefined &&
                      bankDetails?.account?.ifsc !== null &&
                      bankDetails?.account?.ifsc}
                  </h6>

                  <p>Account Number:</p>
                  <h6>
                    {bankDetails?.account?.accNum !== undefined &&
                      bankDetails?.account?.accNum !== null &&
                      bankDetails?.account?.accNum}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
